var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0576 2.94502C20.9381 2.50105 20.7041 2.09626 20.379 1.77115C20.0539 1.44604 19.6491 1.21203 19.2051 1.09252C17.5701 0.650025 11.0001 0.650024 11.0001 0.650024C11.0001 0.650024 4.43013 0.650025 2.79513 1.09252C2.35116 1.21203 1.94637 1.44604 1.62126 1.77115C1.29615 2.09626 1.06214 2.50105 0.942635 2.94502C0.636773 4.6124 0.488619 6.30487 0.500135 8.00002C0.488619 9.69518 0.636773 11.3877 0.942635 13.055C1.06214 13.499 1.29615 13.9038 1.62126 14.2289C1.94637 14.554 2.35116 14.788 2.79513 14.9075C4.43013 15.35 11.0001 15.35 11.0001 15.35C11.0001 15.35 17.5701 15.35 19.2051 14.9075C19.6491 14.788 20.0539 14.554 20.379 14.2289C20.7041 13.9038 20.9381 13.499 21.0576 13.055C21.3635 11.3877 21.5117 9.69518 21.5001 8.00002C21.5117 6.30487 21.3635 4.6124 21.0576 2.94502ZM8.90014 11.15V4.85002L14.3526 8.00002L8.90014 11.15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c3a634bf4aaee5bcc479c59fa8bf0561.svg";
export { ForwardRef as ReactComponent };